var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-1 -1 122 122",
    style: {
      enableBackground: "new 10 10 122 122"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FA242E;stroke:#FA242E;stroke-width:1px;}\n\t.st1{fill:none;stroke:#FA242E;stroke-linecap:round;stroke-miterlimit:10;stroke-width:2px;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M60,1.2c32.4,0,58.8,26.4,58.8,58.8S92.4,118.8,60,118.8S1.2,92.4,1.2,60S27.6,1.2,60,1.2 M60,0.2 C27,0.2,0.2,27,0.2,60S27,119.8,60,119.8S119.8,93,119.8,60S93,0.2,60,0.2L60,0.2z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "40.2,28.4 79.8,28.4 79.8,91.6 40.2,91.6  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 70.3,
    y1: 28.4,
    x2: 70.3,
    y2: 91.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 65.6,
    y1: 60,
    x2: 40.2,
    y2: 60
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "46.1,54.1 40.2,60 46.1,65.9  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIcon);
export default __webpack_public_path__ + "static/media/backIcon.f3adc8c0e9fd1b55f4c5676f7772b81f.svg";
export { ForwardRef as ReactComponent };